import React, { Component } from 'react';
import Chart from 'chart.js';
import { Paper, Typography } from '@material-ui/core';
import * as strings from '../../helpers/strings';

class LineComponent extends Component {
  chartRef = React.createRef();
  calculatedValueRef = React.createRef();

  componentDidMount() {
    const ctx = this.chartRef.current.getContext('2d');

    const gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
    gradientStroke.addColorStop(0, '#2C3E50');
    gradientStroke.addColorStop(1, '#343A40');
    
    const gradientFill = ctx.createLinearGradient(500, 0, 100, 0);
    gradientFill.addColorStop(0, 'rgba(44, 62, 80, 0.6)');
    gradientFill.addColorStop(1, 'rgba(52, 58, 64, 0.6)');

    this.myChart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: ['2018', '2019', '2020', '2021', '2022', '2023'],
        datasets: [
          {
            label: 'PV Performance',
            borderColor: gradientStroke,
            pointBorderColor: gradientStroke,
            pointBackgroundColor: gradientStroke,
            pointHoverBackgroundColor: gradientStroke,
            pointHoverBorderColor: gradientStroke,
            pointBorderWidth: 10,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            backgroundColor: gradientFill,
            borderWidth: 4,
            data: [81, 79, 78, 77, 78,77],
          },
        ],
      },
      options: {
        animation: {
          easing: 'easeInOutBack',
        },

        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'kWh'
              },
              ticks: {
                fontColor: 'rgba(0,0,0,0.5)',
                fontStyle: 'bold',
                beginAtZero: true,
                maxTicksLimit: 5,
                padding: 20,
              },
              gridLines: {
                drawTicks: false,
                display: false,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                zeroLineColor: 'transparent',
              },
              ticks: {
                padding: 20,
                fontColor: 'rgba(0,0,0,0.5)',
                fontStyle: 'bold',
              },
            },
          ],
        },
      },
    });

    this.calculatePerformanceDegradation();
  }

  componentWillUnmount() {
    this.myChart.destroy();
  }

  calculatePerformanceDegradation = () => {
    const data = this.myChart.data.datasets[0].data;
    const firstValue = data[0];
    const lastValue = data[data.length - 1];
    const degradation = ((lastValue - firstValue) / firstValue) * 100;
    const calculatedValue = `<span style="font-weight: bold"> Performance Degradation:</span> ${degradation.toFixed(2)}%`;
    this.calculatedValueRef.current.innerHTML = calculatedValue;  }

  render() {
    return (
      <Paper className="SmartOMInfo">
        <Typography className="SmartOMTitle" variant="h5" color={strings.colorPrimary}>
          {strings.lblSmartOMPerformance}
        </Typography>
        <div>
          <canvas ref={this.chartRef} />
          <div ref={this.calculatedValueRef} className="CalculatedValue" />
        </div>
      </Paper>
    );
  }
}

export default LineComponent;
